module.exports = __webpack_public_path__ + "static/ga_integration_1-ae3d7f7eedf2b29bf3f907f05c320eb3.png";